import { generatePassword } from '@rp/contracts'
import { Button, Field } from '../../design'
import { MEMBER_PASSWORD_COPY } from './passwordCopy'

type PasswordInputProps = { id: string; value: string; error: string | undefined; onValue: (value: string) => void }

export const PasswordInput = ({ id, value, error, onValue }: PasswordInputProps) => (
  <Field
    id={id}
    label={MEMBER_PASSWORD_COPY.label}
    hint={MEMBER_PASSWORD_COPY.hint}
    {...(error === undefined ? {} : { error })}
  >
    {({ id: inputId, describedBy }) => (
      <span className="password-entry">
        <input
          id={inputId}
          type="text"
          className="num"
          autoComplete="off"
          spellCheck={false}
          aria-describedby={describedBy}
          aria-invalid={error === undefined ? undefined : true}
          value={value}
          onChange={(event) => onValue(event.target.value)}
        />
        <Button onClick={() => onValue(generatePassword())}>{MEMBER_PASSWORD_COPY.generate}</Button>
      </span>
    )}
  </Field>
)
